import React, { Component } from 'react'
import { connect } from 'react-redux'
import Divider from 'material-ui/Divider'
import dataActions from 'actions/dataActions'
import attachmentOverlayActions from 'actions/attachmentOverlayActions'
import rightStackActions from 'actions/rightStackActions'
import newCommentActions from 'actions/newCommentActions'
import { dirtyRead, doc, edit, routing, login } from 'selectors/common'
import LeftSide from './LeftSide'
import RightSide from './RightSide'
import attachmentActions from 'actions/attachmentActions'

import FormHeader from 'components/FormHeader'
import FormFooter from 'components/FormFooter'
import Deleted from 'components/Deleted'
import TaskStatusIcon from '../tasks/StatusIcon'
import { dependencies } from 'selectors/tasks'

let select = dirtyRead(
	(state, props) => {
		return {
			doc: doc(state, props.id || props.routeParams.id)
		  , tasks: dependencies(state, {projectID:(doc(state, props.id || props.routeParams.id) || {}).projectID}) || []
		}
	}
)

export class Task extends Component{
	render(){
			let { props } = this
			let doc = props.doc || {}
			let objectID = this.props.id || this.props.routeParams.id
			let colspan = this.props.colspan || 2
			let widthColumns = "100%" //(this.props.style && this.props.width && colspan)?(this.props.width.split('px')[0]/colspan)-18+"px":"50%"
			return (
				<div
					style={{
						display: "inline-block"
					  , width: "100%"
					  , backgroundColor: "#FFF"
					  , overflow: "hidden"
					}}
				>
					<FormHeader
						title="Task"
						statusIcon={<div style={{position:"relative", top:"-6px", left:"7px"}}><img src={".." + "/static/img/tasks_g48.png"}
							style={{height: "22px !important", width: "22px"}}
						/></div>}
						masterDetail={this.props.masterDetail || false}
						entity='task'
						deleteDisabled={props.tasks && props.tasks.length==1? "It is a single-task project." : false}
						objectID= {objectID}
					/>
					{(!this.props.doc)?
						<Deleted />
						:
						<div style={{position:"relative", height:"calc(100vh - 64px)", overflowX: "hidden", backgroundColor: "#f3f5f4"}}>
						<main style={{height:"calc(100vh - 64px)", display:(colspan>1)?"flex":"block"}}>
							<LeftSide objectID={objectID} colspan={colspan}/>
							{colspan==1 && <Divider style={{marginTop: "0px"}}/>}
							<RightSide objectID={objectID} colspan={colspan}/>
						</main>
						{objectID &&
							<div
								style={{
									position:"fixed"
							      , zIndex:"9999"
								  , bottom:"3px"
								  , right:"17px"
								  , boxSizing: "borderBox"
								  , maringRight: "17px"
								}}
							>
								<FormFooter masterDetail={this.props.masterDetail || false} objectID={objectID} />
							</div>
						}
						</div>
					}

				</div>
			)
	}
}

export default connect(select)(Task)



// WEBPACK FOOTER //
// ./src/routes/manager/taskForm/index.js